import {PropsWithChildren} from 'react';
import {cn} from '@/lib/utils';

type Props = PropsWithChildren & {
  className?: string;
};

export default function NavBreadcrumbRoot({className, children}: Props) {
  return (
    <ul
      className={cn(
        "text-gray-600 py-8 inline-block whitespace-nowrap text-sm [&>:not(:last-child)]:after:content-['/'] [&>:not(:last-child)]:after:px-2 text-wrap",
        className,
      )}>
      {children}
    </ul>
  );
}
